import DotBackground from './DotBackground'

export default DotBackground
